"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var objToQuery = function (obj, exclude, parent) {
    if (exclude === void 0) { exclude = []; }
    if (parent === void 0) { parent = null; }
    var query = [];
    Object.entries(obj).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (exclude.indexOf(key) > -1) {
            return;
        }
        var queryKey = (parent) ? "".concat(parent, "[").concat(key, "]") : key;
        if (Array.isArray(value)) {
            value.forEach(function (subValue) { return query.push("".concat(queryKey, "[]=").concat(subValue)); });
        }
        else if (typeof value === 'object') {
            query.push(objToQuery(value, exclude, queryKey));
        }
        else {
            query.push("".concat(queryKey, "=").concat(value));
        }
    });
    return query.join('&');
};
exports.default = objToQuery;
//# sourceMappingURL=objToQuery.js.map